export const PublicPostPreviewConfig = {
  ACCOUNTS_WITH_DISABLED_COMMENTS: ['kruisraket', 'dev7-acc1'],
};
